const NotFound = () => (
  <div>NotFound - 404</div>
);

export default NotFound;
